import { Container } from 'pixi.js';

export class EmptyLayer {
  readonly container = new Container();

  setVisible(visible: boolean): void {
    this.container.visible = visible;
  }

  destroy(): void {
    this.container.removeChildren();
    this.container.destroy();
  }
}
